// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/imputation_policy_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ImputationPolicy } from "./imputation_policy_model_pb";
import { file_bffuser_v1_imputation_policy_model } from "./imputation_policy_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/imputation_policy_service.proto.
 */
export const file_bffuser_v1_imputation_policy_service: GenFile = /*@__PURE__*/
  fileDesc("CipiZmZ1c2VyL3YxL2ltcHV0YXRpb25fcG9saWN5X3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiHAoaR2V0SW1wdXRhdGlvblBvbGljeVJlcXVlc3QiSwobR2V0SW1wdXRhdGlvblBvbGljeVJlc3BvbnNlEiwKBnBvbGljeRgBIAEoCzIcLmJmZnVzZXIudjEuSW1wdXRhdGlvblBvbGljeSKOAQodVXBkYXRlSW1wdXRhdGlvblBvbGljeVJlcXVlc3QSNAoGcG9saWN5GAEgASgLMhwuYmZmdXNlci52MS5JbXB1dGF0aW9uUG9saWN5Qga6SAPIAQESNwoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrQga6SAPIAQEiTgoeVXBkYXRlSW1wdXRhdGlvblBvbGljeVJlc3BvbnNlEiwKBnBvbGljeRgBIAEoCzIcLmJmZnVzZXIudjEuSW1wdXRhdGlvblBvbGljeTL2AQoXSW1wdXRhdGlvblBvbGljeVNlcnZpY2USaAoTR2V0SW1wdXRhdGlvblBvbGljeRImLmJmZnVzZXIudjEuR2V0SW1wdXRhdGlvblBvbGljeVJlcXVlc3QaJy5iZmZ1c2VyLnYxLkdldEltcHV0YXRpb25Qb2xpY3lSZXNwb25zZSIAEnEKFlVwZGF0ZUltcHV0YXRpb25Qb2xpY3kSKS5iZmZ1c2VyLnYxLlVwZGF0ZUltcHV0YXRpb25Qb2xpY3lSZXF1ZXN0GiouYmZmdXNlci52MS5VcGRhdGVJbXB1dGF0aW9uUG9saWN5UmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_imputation_policy_model, file_buf_validate_validate, file_google_protobuf_field_mask]);

/**
 * GetImputationPolicyRequest has no fields.
 *
 * @generated from message bffuser.v1.GetImputationPolicyRequest
 */
export type GetImputationPolicyRequest = Message<"bffuser.v1.GetImputationPolicyRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetImputationPolicyRequest.
 * Use `create(GetImputationPolicyRequestSchema)` to create a new message.
 */
export const GetImputationPolicyRequestSchema: GenMessage<GetImputationPolicyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_imputation_policy_service, 0);

/**
 * @generated from message bffuser.v1.GetImputationPolicyResponse
 */
export type GetImputationPolicyResponse = Message<"bffuser.v1.GetImputationPolicyResponse"> & {
  /**
   * @generated from field: bffuser.v1.ImputationPolicy policy = 1;
   */
  policy?: ImputationPolicy;
};

/**
 * Describes the message bffuser.v1.GetImputationPolicyResponse.
 * Use `create(GetImputationPolicyResponseSchema)` to create a new message.
 */
export const GetImputationPolicyResponseSchema: GenMessage<GetImputationPolicyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_imputation_policy_service, 1);

/**
 * UpdateImputationPolicyRequest updates the organization's ImputationPolicy.
 * organization_id and the acting member are derived from the eauth session by
 * the BFF handler. update_mask selects which fields are written (see the RPC
 * comment). Accepted paths are the top-level field names of ImputationPolicy:
 *
 * 	demand_method, generation_method_order
 *
 * Specifying generation_method_order replaces the entire array. Unknown /
 * empty / duplicate paths are rejected by the backend handler.
 *
 * @generated from message bffuser.v1.UpdateImputationPolicyRequest
 */
export type UpdateImputationPolicyRequest = Message<"bffuser.v1.UpdateImputationPolicyRequest"> & {
  /**
   * Policy payload. The client must populate every field because strict
   * protovalidate rules apply to the whole message, but only the fields named
   * in update_mask are persisted.
   *
   * @generated from field: bffuser.v1.ImputationPolicy policy = 1;
   */
  policy?: ImputationPolicy;

  /**
   * Paths to update. Must not be empty. Each path must be a top-level field
   * name of ImputationPolicy (no nested dot-separated paths, no array
   * indexing).
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message bffuser.v1.UpdateImputationPolicyRequest.
 * Use `create(UpdateImputationPolicyRequestSchema)` to create a new message.
 */
export const UpdateImputationPolicyRequestSchema: GenMessage<UpdateImputationPolicyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_imputation_policy_service, 2);

/**
 * @generated from message bffuser.v1.UpdateImputationPolicyResponse
 */
export type UpdateImputationPolicyResponse = Message<"bffuser.v1.UpdateImputationPolicyResponse"> & {
  /**
   * The full ImputationPolicy after the update has been applied.
   *
   * @generated from field: bffuser.v1.ImputationPolicy policy = 1;
   */
  policy?: ImputationPolicy;
};

/**
 * Describes the message bffuser.v1.UpdateImputationPolicyResponse.
 * Use `create(UpdateImputationPolicyResponseSchema)` to create a new message.
 */
export const UpdateImputationPolicyResponseSchema: GenMessage<UpdateImputationPolicyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_imputation_policy_service, 3);

/**
 * ImputationPolicyService exposes the organization-wide 欠損補完方式 setting
 * (docs/specs/demand/missing-data-interpolation.md) to the frontend.
 *
 * The acting member is never exposed to the frontend; the BFF handler derives
 * it from the eauth session.
 *
 * @generated from service bffuser.v1.ImputationPolicyService
 */
export const ImputationPolicyService: GenService<{
  /**
   * GetImputationPolicy returns the current organization's policy. When no row
   * has been saved yet, the spec defaults are returned (demand = PREV_TIME per
   * AC-002, generation = [PLAN_VALUE, PREV_TIME] per AC-008) with updated_at
   * unset.
   *
   * @generated from rpc bffuser.v1.ImputationPolicyService.GetImputationPolicy
   */
  getImputationPolicy: {
    methodKind: "unary";
    input: typeof GetImputationPolicyRequestSchema;
    output: typeof GetImputationPolicyResponseSchema;
  },
  /**
   * UpdateImputationPolicy applies an update with last-writer-wins semantics
   * (spec Discussion 後勝ち; the screen saves each change immediately).
   *
   * update_mask.paths selects which fields are written: only the named fields
   * are persisted, and fields not named keep their currently saved value.
   *
   * The client must still populate EVERY field of policy, because the payload
   * carries strict protovalidate rules (enum not_in [0], repeated min_items)
   * that a true partial message would fail — see ImputationPolicy in
   * imputation_policy_model.proto and TODO(#556). Values of unnamed fields are
   * ignored: they may be stale, and writing them back would clobber another
   * user's concurrent edit of a different field.
   *
   * The BFF handler passes the update_mask through to the backend without
   * reconstruction.
   *
   * @generated from rpc bffuser.v1.ImputationPolicyService.UpdateImputationPolicy
   */
  updateImputationPolicy: {
    methodKind: "unary";
    input: typeof UpdateImputationPolicyRequestSchema;
    output: typeof UpdateImputationPolicyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_imputation_policy_service, 0);

